import AjaxCall from '../ws/ajax-call';
import AjaxUrls from '../constants/ajax-url';
import TrackingAction from '../constants/tracking-action';
import ParamStore from '../logic/stores/param-store';
import JmServices from '../ws/jm-services';
import ErrorLogger from '../infrastructure/error-logger';
import FormUiState from '../logic/form-ui-state';

export default class ClsServices {

    static get clsScope() {
        return 'openid offline_access';
    }

    static get _clsGrantType() {
        return 'code';
    }

    static register(componentId, options) {
        try {
            if (!options.email
                || options.activate === undefined || options.activate === null
                || options.keepLoggedIn === undefined || options.keepLoggedIn === null
                || options.sendProductInformation === undefined || options.sendProductInformation === null) {
                throw new Error(`JLS Missing ClsServices.register preconditions; Options: ${JSON.stringify(options)}`);
            }

            return AjaxCall.call({
                isAsync: false,
                url: AjaxUrls.cls.register.url.replace('{clsAbsUrl}', ParamStore.getModel(componentId).clsEndpoint),
                method: AjaxUrls.cls.register.method,
                requestData: {
                    username: options.email,
                    password: options.password,
                    auto_login: !!options.keepLoggedIn,
                    auto_email: !!options.sendProductInformation,
                    client_id: ParamStore.getModel(componentId).clsClientId,
                    redirect_uri: ParamStore.getModel(componentId).clsReturnUrl,
                    ui_locales: ParamStore.getModel(componentId).lang5,
                    scope: ClsServices.clsScope,
                    grant_type: ClsServices._clsGrantType,
                    activate_email: !!options.activate
                }
            }).then(
                (responseData) => { // onFulfilled

                    try {
                        if (ParamStore.getModel(componentId).callbacks.successfulRegistrationAtClsSide) {
                            ParamStore.getModel(componentId).callbacks.successfulRegistrationAtClsSide();
                        }

                        JmServices.trackEvent(componentId, {trackingValue: TrackingAction.jlsSuccessfulRegistrationAtClsSide});

                        if (!options.sendProductInformation) {
                            JmServices.trackEvent(componentId, {trackingValue: TrackingAction.jlsSuccessfulRegistrationAtClsSideSendMeProductInformationUnchecked});
                        }

                        ClsServices._executeResponseForm(componentId, responseData);
                    } catch (ex) {
                        JmServices.trackEvent(componentId, {trackingValue: TrackingAction.jlsFailedRegistrationAtClsSide});
                        ErrorLogger.log(ex);

                        return {error: true};
                    }
                },
                () => { // onRejected
                    JmServices.trackEvent(componentId, {trackingValue: TrackingAction.jlsFailedRegistrationAtClsSide});
                    return {error: true};
                }
            )
        }
        catch (ex) {
            ErrorLogger.log(ex);
            throw ex;
        }
    }

    static login(componentId, options) {
        try {
            if (!options.email || !options.password || !options.clsProviderType ||
                options.keepLoggedIn === undefined || options.keepLoggedIn === null) {
                options.password = '';
                throw new Error(`JLS Missing ClsServices.login preconditions; Options: ${JSON.stringify(options)}`);
            }

            return AjaxCall.call({
                isAsync: false,
                url: AjaxUrls.cls.login.url.replace('{clsAbsUrl}', ParamStore.getModel(componentId).clsEndpoint),
                method: AjaxUrls.cls.login.method,
                requestData: {
                    username: options.email,
                    password: options.password,
                    auto_login: options.keepLoggedIn,
                    provider: options.clsProviderType,
                    client_id: ParamStore.getModel(componentId).clsClientId,
                    redirect_uri: ParamStore.getModel(componentId).clsReturnUrl,
                    ui_locales: ParamStore.getModel(componentId).lang5,
                    scope: ClsServices.clsScope,
                    grant_type: ClsServices._clsGrantType,
                }
            }).then(
                (responseData) => { // onFulfilled

                    try {
                        if (ParamStore.getModel(componentId).callbacks.successfulLoginAtClsSide) {
                            ParamStore.getModel(componentId).callbacks.successfulLoginAtClsSide();
                        }

                        // TODO: Tracking
                        ClsServices._executeResponseForm(componentId, responseData);
                    } catch (ex) {
                        // TODO: Tracking
                        ErrorLogger.log(ex);

                        return {error: true, generic: true};
                    }
                },
                () => { // onRejected
                    // TODO: Tracking
                    return {error: true, invalidCredentials: true};
                }
            )
        }
        catch (ex) {
            ErrorLogger.log(ex);
            throw ex;
        }
    }

    static isEmailExisting(componentId, options) {
        try {
            if (!options.email) {
                throw new Error(`JLS Missing ClsServices.isEmailExisting preconditions; Options: ${JSON.stringify(options)}`);
            }

            return AjaxCall.call({
                isAsync: false,
                url: AjaxUrls.cls.isEmailExists.url.replace('{clsAbsUrl}', ParamStore.getModel(componentId).clsEndpoint),
                method: AjaxUrls.cls.isEmailExists.method,
                requestData: {
                    username: options.email,
                    client_id: ParamStore.getModel(componentId).clsClientId
                }
            })
        }
        catch (ex) {
            ErrorLogger.log(ex);
            throw ex;
        }
    }

    static isEmailFederated(componentId, options) {
        try {
            if (!options.email) {
                throw new Error(`JLS Missing ClsServices.isDomainExisting preconditions; Options: ${JSON.stringify(options)}`);
            }

            return AjaxCall.call({
                isAsync: false,
                url: AjaxUrls.cls.isEmailFederated.url.replace('{clsAbsUrl}', ParamStore.getModel(componentId).clsEndpoint),
                method: AjaxUrls.cls.isEmailFederated.method,
                requestData: {
                    username: options.email,
                    client_id: ParamStore.getModel(componentId).clsClientId
                }
            })
        }
        catch (ex) {
            ErrorLogger.log(ex);
            throw ex;
        }
    }

    static _executeResponseForm(componentId, responseData) {
        if (!responseData.form || responseData.error_type) {
            throw new Error(`JLS Missing ClsServices._executeResponseForm preconditions; ResponseData: ${JSON.stringify(responseData)}`);
        }

        FormUiState.setDisposed(componentId);

        document.getElementById(ParamStore.getModel(componentId).clsExecutionArea).innerHTML =
            `<div id='cls-form-container' style='display:none'>${responseData.form}<div>`;
        let clsForm = document.getElementById('cls-form-container').firstChild;
        if(clsForm.nodeName.toLocaleLowerCase() === 'form') {
            clsForm.submit();
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/ws/cls-services.js
 **/